/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsCycle } from '../../models/submissions-cycle';
import { SubmissionsCycleCreate } from '../../models/submissions-cycle-create';

export interface CreateSubmissionsCycleInternalV2SubmissionsCyclePost$Params {
  org: string;
      body: SubmissionsCycleCreate
}

export function createSubmissionsCycleInternalV2SubmissionsCyclePost(http: HttpClient, rootUrl: string, params: CreateSubmissionsCycleInternalV2SubmissionsCyclePost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsCycle>> {
  const rb = new RequestBuilder(rootUrl, createSubmissionsCycleInternalV2SubmissionsCyclePost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionsCycle>;
    })
  );
}

createSubmissionsCycleInternalV2SubmissionsCyclePost.PATH = '/_internal/v2/submissions-cycle';
